/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type VehicleStatus = typeof VehicleStatus[keyof typeof VehicleStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VehicleStatus = {
  Active: 'Active',
  Disabled: 'Disabled',
  Maintenance: 'Maintenance',
} as const;
